import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SearchSubProject from '../../components/forms/searchSubProject/SearchSubProject'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import {
  getBillpaymentFormReportSubmitPdf,
  getBillpaymentperiodFormReportSubmitPdf,
} from '../../redux/actions/subProjectReport'

export default function BillPaymentReportWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isSucceed, setIsSucceed] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [disabledValue, setDisableValue] = useState({})
  const [previewPdf, setPreviewPdf] = useState()
  const [mainProjectOption, setMainProjectOption] = useState([])
  const [subProjectOption, setSubProjectOption] = useState([])
  const [installmentOption, setInstallmentOption] = useState([])

  useEffect(() => {
    console.log('load ProjectName projectId')
    formSchema.buttonText.previewButtonName = 'แสดงตัวอย่างก่อนพิมพ์'
    buttonDisabled()
  }, [])

  const buttonDisabled = () => {
    const disValue = {
      buttonText: formSchema.buttonText.disabled,
      reportDocumentsOption: formSchema.searchObject.reportDocumentsOption.disabled,
      subProjectOption: formSchema.searchObject.subProjectOption.disabled,
      mainProjectOption: formSchema.searchObject.mainProjectOption.disabled,
      installment: formSchema.searchObject.installment.disabled,
    }

    setDisableValue(disValue)
  }

  const handleDownloadPdf = async (data) => {
    await handleCallReportSubmitPdf(data)
    //await onDownload(previewPdf)
  }

  const onDownload = async (fileObj, fileName) => {
    if (fileObj) {
      const url = window.URL.createObjectURL(fileObj)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName || `ใบเบิกเงิน`)
      document.body.appendChild(link)
      link.click()
    }
  }

  const handleChangeReportDocuments = (reportType) => {
    // console.log('handleChangeReportDocuments ', reportType)

    const report = formSchema.valuesObject.reportDocuments.find(
      (reportDocument) => reportDocument.value === reportType
    )

    setMainProjectOption(report.mainProject)

    const disValue = {
      buttonText: formSchema.buttonText.disabled,
      reportDocumentsOption: formSchema.searchObject.reportDocumentsOption.disabled,
      subProjectOption: formSchema.searchObject.mainProjectOption.disabled,
      mainProjectOption: false,
      installment: formSchema.searchObject.installment.disabled,
    }

    setDisableValue(disValue)
  }

  const handleCheangMainProject = (projectId) => {
    // console.log('handleCheangMainProject=> ', projectId, mainProjectOption)

    const mainProject = mainProjectOption.find((mainProject) => mainProject.value === projectId)

    setSubProjectOption(mainProject.subProject)

    const disValue = {
      buttonText: formSchema.buttonText.disabled,
      reportDocumentsOption: formSchema.searchObject.reportDocumentsOption.disabled,
      subProjectOption: false,
      mainProjectOption: false,
      installment: formSchema.searchObject.installment.disabled,
    }
    setDisableValue(disValue)
  }

  const handleChangeSubProject = (subProjectId) => {
    console.log('handleChangeSubProject=> ', subProjectId)

    const subProject = subProjectOption.find((subProject) => subProject.value === subProjectId)

    console.log('000 ', subProject.installment)
    setInstallmentOption(subProject.installment)

    const disValue = {
      buttonText: formSchema.buttonText.disabled,
      subProjectOption: false,
      mainProjectOption: false,
      installment: false,
    }
    setDisableValue(disValue)
  }

  const handleChangeInstallment = (data) => {
    console.log('handleChangeInstallment=> ', data)

    const disValue = {
      buttonText: false,
      subProjectOption: false,
      mainProjectOption: false,
      installment: false,
    }
    setDisableValue(disValue)
  }

  const handleCancel = () => {
    setIsSucceed(false)
    setPreviewPdf(null)
    for (const key in getValues()) {
      setValue(key, null)
    }
    buttonDisabled()
  }

  const handlePreviewPdf = async (data) => {
    await handleCallReportSubmitPdf(data)
    setIsSucceed(true)
  }

  const handleCallReportSubmitPdf = async (data) => {
    startLoading()
    setIsPdfError(false)
    setIsLoadingPDF(true)

    try {
      let response

      if (data.reportDocumentsOption === 'billPayment') {
        response = await getBillpaymentFormReportSubmitPdf(data.subProjectOption, data.installment)
        onDownload(response, 'ใบเบิกเงินโครงการย่อย')
      } else if (data.reportDocumentsOption === 'billPaymentByPeriodNo') {
        response = await getBillpaymentperiodFormReportSubmitPdf(
          data.subProjectOption,
          data.installment
        )
        onDownload(response, 'รายงานสรุปประกอบการอนุมัติเบิกเงินตามงวด')
      }

      if (response) {
        //setPreviewPdf(response)
        setIsPdfError(false)
      } else {
        setIsPdfError(true)
      }
    } catch (e) {
      console.error(e)
      setIsPdfError(true)
    }

    setIsLoadingPDF(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema && (
          <SearchSubProject
            schema={formSchema}
            mainProjectOption={mainProjectOption}
            subProjectOption={subProjectOption}
            installmentOption={installmentOption}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            onChangeReportDocuments={handleChangeReportDocuments}
            onChangeMainProject={handleCheangMainProject}
            onChangeSubProject={handleChangeSubProject}
            onChangeInstallment={handleChangeInstallment}
            disabledValue={disabledValue}
          />
        )}

        <hr />

        <ButtonPanelWidget
          isDisabled={disabledValue.buttonText}
          isEdit={isEdit}
          isError={isError}
          buttonText={formSchema.buttonText}
          onPrint={handleSubmit(handleDownloadPdf)}
          onPreview={handleSubmit(handlePreviewPdf)}
          onCancel={(el) => {
            setIsError(false)
            handleCancel()
          }}
        />
      </Panel>

      <br />

      {isSucceed && (
        <Panel
          shaded
          header={formSchema.reportName}
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
        >
          {isPdfError ? (
            <Message showIcon type="error" description={'ไม่พบไฟล์ PDF'} />
          ) : (
            <>
              <PdfRenderWidgets
                isShaded={false}
                file={previewPdf}
                isLoading={isLoadingPDF}
                isShowbutton={false}
                onReload={() => handleGetProjectSubmitPdf(projectId)}
              />
            </>
          )}
        </Panel>
      )}
    </>
  )
}
